import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';

export const openMultiUpdateOrderModal = asyncModalAdapter({
	featureFlag: 'REACT_MULTI_UPDATE_ORDER',
	upModalName: 'updateOrderMulti',
	openModalName: 'MultiUpdateOrder',
	rejectOnEvent: true
});
